export default {
  namespaced: true,
  state: {
    isCollapse: false,
  },
  mutations: {
    updateCollapse(state,status) {
      state.isCollapse = status
    }
  }
}